// Google sign-in. Staff are on Google Workspace at fleetly.co.za, and
// public.cockpit_access is already keyed on that same email address, so the
// existing permission matrix needs no migration: the JWT's email is the key it
// was always looking up.
//
// `hd: 'fleetly.co.za'` asks Google to show only Fleetly accounts in the
// chooser. That is a convenience, NOT a security control: a hint in a redirect
// URL is client-side and trivially removed. The real enforcement is
// ALLOWED_EMAIL_DOMAINS in the Worker, checked server-side on every request,
// plus cockpit_access itself.
import { useState } from 'react'
import { supabase } from '../lib/supabase'

export function SignIn() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function signIn() {
    setBusy(true)
    setError(null)
    const { error: err } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        queryParams: { hd: 'fleetly.co.za', prompt: 'select_account' },
      },
    })
    if (err) {
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <div className="flex h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-8 shadow-retool-md">
        <div className="mb-6 flex items-center gap-3">
          <img
            src="/fleetly-mark.svg"
            alt=""
            aria-hidden="true"
            width={40}
            height={40}
            className="h-10 w-10 shrink-0"
          />
          <div className="leading-tight">
            <h1 className="text-lg font-semibold text-foreground">Fleetly</h1>
            <p className="text-[11px] font-medium uppercase tracking-wide text-[hsl(var(--brand))]">
              Driving Change
            </p>
          </div>
        </div>

        <h2 className="text-base font-medium text-foreground">Cockpit sign in</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Use your Fleetly Google account. Your access is set by an admin.
        </p>

        <button
          type="button"
          onClick={signIn}
          disabled={busy}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-md bg-[hsl(var(--brand))] px-4 py-2.5 text-sm font-medium text-[hsl(var(--brand-foreground))] transition-colors hover:bg-[hsl(var(--brand-strong))] disabled:opacity-60"
        >
          {busy ? 'Redirecting…' : 'Continue with Google'}
        </button>

        {error && (
          <p className="mt-4 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-xs text-destructive">
            {error}
          </p>
        )}
      </div>
    </div>
  )
}
